import React from 'react'
import CreatableSelect from "react-select/creatable";
import { FaTrash } from 'react-icons/fa6'

const StatementModalInput = ({
    itemCategory,
    handleCategoryChange,
    formData,
    handleChange,
    handleSelectChange,
    removeRow,
    typeOptions,
    stockTypeOptions,
    uomSelectOptions,
    unitUomSelectOptions,
    readonlyClass,
    editableClass,
    selectStyles,
}) => {
    return (
        <>
            <div className="mb-2 !text-left">
                <div className="flex bg-gray-100 p-1 rounded-xl gap-1 max-w-fit">
                    <button
                        type="button"
                        onClick={() => handleCategoryChange("raw_material")}
                        className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${itemCategory === "raw_material"
                            ? "bg-white text-blue-600 shadow-sm"
                            : "text-gray-600"
                            }`}
                    >
                        Raw Material
                    </button>

                    <button
                        type="button"
                        onClick={() => handleCategoryChange("production")}
                        className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${itemCategory === "production"
                            ? "bg-white text-blue-600 shadow-sm"
                            : "text-gray-600"
                            }`}
                    >
                        Production
                    </button>
                </div>
            </div>

            <div className="space-y-6 max-h-[65vh] overflow-y-auto pr-1 tiny-scrollbar">
                {formData.map((item, index) => (
                    <div
                        key={index}
                        className="border border-gray-200 rounded-lg p-4 bg-gray-50"
                    >
                        <div className="flex items-center justify-between mb-2">
                            <h3 className="font-semibold text-gray-800 text-lg">
                                Item #{index + 1}
                            </h3>

                            {formData.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => removeRow(index)}
                                    className="text-red-500 hover:text-red-700"
                                >
                                    <FaTrash />
                                </button>
                            )}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">

                            {/* Group Name */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Group Name*
                                </label>
                                <input
                                    type="text"
                                    name="GroupName"
                                    value={item.GroupName}
                                    onChange={(e) => handleChange(index, e)}
                                    className={itemCategory === "production" ? readonlyClass : editableClass}
                                    readOnly={itemCategory === "production"}
                                    required
                                />
                            </div>

                            {/* Item Name */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Item Name*
                                </label>
                                <input
                                    type="text"
                                    name="ItemName"
                                    value={item.ItemName}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                    required
                                />
                            </div>

                            {/* Brand Name */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Brand Name
                                </label>
                                <input
                                    type="text"
                                    name="BrandName"
                                    value={item.BrandName}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                />
                            </div>

                            {/* Vendor Name */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Vendor Name
                                </label>
                                <input
                                    type="text"
                                    name="vendor_name"
                                    value={item.vendor_name}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                />
                            </div>

                            {/* Type */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Type*
                                </label>
                                <select
                                    name="Type"
                                    value={item.Type}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                >
                                    {typeOptions.map(option => (
                                        <option key={option} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Stock Type */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Stock Type*
                                </label>
                                <select
                                    name="stocktype"
                                    value={item.stocktype || ""}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                    required
                                >
                                    <option value="">Select Stock Type</option>
                                    {stockTypeOptions.map(option => (
                                        <option key={option} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Primary Unit */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Primary Unit*
                                </label>
                                <CreatableSelect
                                    options={uomSelectOptions}
                                    value={item.UOM ? { label: item.UOM, value: item.UOM } : null}
                                    onChange={(selected) => handleSelectChange(index, "UOM", selected)}
                                    classNamePrefix="select"
                                    className="basic-single text-left"
                                    styles={selectStyles}
                                    menuPosition="fixed"
                                />
                            </div>

                            {/* Secondary Unit — drives Unit Definition UOM */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Secondary Unit*
                                </label>
                                <CreatableSelect
                                    options={unitUomSelectOptions}
                                    value={item.itemUom ? { label: item.itemUom, value: item.itemUom } : null}
                                    onChange={(selected) => handleSelectChange(index, "itemUom", selected)}
                                    classNamePrefix="select"
                                    className="basic-single text-left"
                                    styles={selectStyles}
                                    menuPosition="fixed"
                                    placeholder="e.g. gm, ml, pcs"
                                />
                            </div>

                            {/* Current Stock */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Current Stock*
                                </label>
                                <input
                                    type="number"
                                    name="CurrentLevel"
                                    value={item.CurrentLevel}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                    step="0.01"
                                />
                            </div>

                            {/* Rate */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Rate*
                                </label>
                                <input
                                    type="number"
                                    name="Rate"
                                    value={item.Rate}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                    step="0.01"
                                />
                            </div>

                            {/* Total */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Total
                                </label>
                                <input
                                    type="text"
                                    value={item.Total}
                                    readOnly
                                    className={readonlyClass}
                                />
                            </div>

                            <div></div>

                            {/* Unit Definition — quantity field; UOM mirrors secondary_unit */}
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Unit Definition*
                                </label>

                                <input
                                    type="number"
                                    name="itemUnit"
                                    value={item.itemUnit}
                                    onChange={(e) => handleChange(index, e)}
                                    className={editableClass}
                                    step="0.01"
                                    min="0.01"
                                    required
                                    placeholder="e.g. 1000"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 mb-1.5 font-semibold text-left">
                                    Unit UOM
                                </label>

                                <input
                                    type="text"
                                    value={item.itemUom || ""}
                                    readOnly
                                    className={`${readonlyClass} w-24 flex-shrink-0`}
                                    placeholder="UOM"
                                />
                            </div>

                            {/* Taxable + Expiry */}
                            <div className="md:col-span-2 flex flex-wrap items-center gap-6 mt-2">
                                <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                                    <input
                                        type="checkbox"
                                        name="taxable"
                                        checked={item.taxable}
                                        onChange={(e) => handleChange(index, e)}
                                    />
                                    Taxable
                                </label>

                                <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                                    <input
                                        type="checkbox"
                                        name="hasExpiry"
                                        checked={item.hasExpiry}
                                        onChange={(e) => handleChange(index, e)}
                                    />
                                    Has Expiry
                                </label>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default StatementModalInput;